/**
 * Copyright 2025 Phenix Real Time Solutions, Inc. Confidential and Proprietary. All Rights Reserved.
 */

import PropTypes from 'prop-types';
import Select from './Select';
import {bitRates} from '../data/BitRates';

export const BitRateSelect = ({defaultValue, onChange, disabled}) => {
  const options = bitRates.map(bitRate => ({
    value: bitRate.value,
    label: bitRate.label
  }));

  return (
    <Select
      defaultValue={defaultValue}
      onChange={onChange}
      disabled={disabled}
      options={options}
    />
  );
};

BitRateSelect.propTypes = {
  defaultValue: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired
};